'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosNavigateOutline = function IoIosNavigateOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 5c-4 0-7.8 1.6-10.6 4.5s-4.4 6.5-4.4 10.5 1.6 7.7 4.4 10.5 6.6 4.5 10.6 4.5 7.7-1.6 10.5-4.5 4.5-6.5 4.5-10.5-1.7-7.7-4.5-10.5-6.6-4.5-10.5-4.5z m0-1.2c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m7.5 8.7l-7.5 17.5v-10h-10z' })
        )
    );
};

exports.default = IoIosNavigateOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-navigate-outline.js
// module id = 2456
// module chunks = 0